import React, { useEffect } from 'react';
import Loading from "../../components/utils/Loading";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from 'react-router-dom/dist';
import { loginWithKey } from '../../reducers/user/userThunks';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

export default function MyGlobeWithPreAuthentication(props) {
  const {enqueueSnackbar} = useSnackbar();
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const history = useNavigate();
  const { iv, content } = useParams();

  const userDetails = useSelector((state) => state.user.currentUser?.accountDetails);
  const loggedError = useSelector(state => state.user.loggedError);

  const authWithKey = async () => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get('id');
    try {
      const thunk = await dispatch(loginWithKey({ iv, content }));
      if (thunk.meta.requestStatus === 'rejected')
        throw new Error('offline')
      enqueueSnackbar(t('toasts.loginSuccess'), { variant: 'success', })
      let route = '/m/statistics';
      if (id)
        route += `?id=${id}`;
      history(route)
    } catch {
      enqueueSnackbar(t('toasts.loginFailed'), { variant: 'error', });
    }
  }

  useEffect(() => {
    if (iv && content)
      authWithKey()
  }, []);

  if (userDetails && !loggedError) {
    return null;
  } else {
    return <Loading />;
  }
}
